<template>
  <div>
    <!-- view modal -->
    <b-modal id="modal-viewCOA" title="View Details" cancel-variant="secondary" ok-title="Ok" cancel-title="Close"
      centered v-model="showModal">
      <div v-if="selectedItem">
        <p><strong>Code:</strong> {{ selectedItem.code }}</p>
        <p><strong>Name:</strong> {{ selectedItem.name }}</p>
        <p><strong>Description:</strong> {{ selectedItem.description }}</p>
        <p>
          <strong>Type: </strong>
          <b-badge variant="primary">
            {{ getAccountTypeText(selectedItem.accountType) }}
          </b-badge>
        </p>

        <!-- <p v-if="selectedItem.Type && selectedItem.Type.variant">
          <strong>Type: </strong>
          <b-badge :variant="selectedItem.Type.variant">{{
            selectedItem.Type.status
          }}</b-badge>
        </p>
        <p v-else>
          <strong>Type:</strong> Not available
        </p> -->
        <p><strong>Balance:</strong> Rs{{ selectedItem.currentBalance }}</p>
        <!-- <p><strong>Tax Type:</strong> {{ selectedItem.TaxType }}</p> -->
        <p v-if="selectedItem.parentAccount">
          <strong>Parent Account:</strong> {{ selectedItem.parentAccount }}
        </p>
      </div>
      <template #modal-footer></template>
    </b-modal>

    <!-- Edit Modal -->
    <b-modal id="modal-editCOA" title="Edit Details" ok-title="Save" cancel-variant="secondary" cancel-title="Cancel"
      centered v-model="showEditModal" @ok="saveChanges">
      <b-form @submit.prevent="saveChanges">
        <b-row>
          <b-col md="6">
            <b-form-group label="Code" label-for="editCode">
              <b-form-input id="editCode" v-model="selectedItem.code" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Name" label-for="editName">
              <b-form-input id="editName" v-model="selectedItem.name" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Description" label-for="editDescription">
              <b-form-textarea id="editDescription" v-model="selectedItem.description" required></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Type" label-for="editType">
              <b-form-select id="editType" v-model="selectedItem.accountType" :options="typeOptions" disabled/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Balance" label-for="editBalance">
              <b-form-input id="editBalance" type="number" v-model.number="selectedItem.currentBalance" required min="0" />
            </b-form-group>
          </b-col>
          <!-- <b-col md="6" class="d-flex align-items-center">
            <b-form-group label="Is Sub Account ?" class="mb-0">
              <b-form-checkbox id="isSubAccount" v-model="selectedItem.isSubAccount" switch>

              </b-form-checkbox>
            </b-form-group>
          </b-col> -->

          <!-- <b-col md="12">
            <b-form-group label="Parent Account" label-for="editParentAccount">
              <b-form-select id="editParentAccount" v-model="selectedItem.parentAccount"
                :options="getParentAccountOptions" :disabled="!selectedItem.isSubAccount"></b-form-select>
            </b-form-group>
          </b-col> -->
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-button @click="saveChanges">
            <feather-icon icon="CheckCircleIcon" class="mr-50" />
            <span>Save</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Add Modal -->
    <b-modal id="addModal" v-model="isAddModalVisible" title="Add Record" centered :hide-footer="true">
      <b-form @submit.prevent="AddCOA">
        <b-row>
          <b-col md="6">
            <b-form-group label="Code">
              <b-form-input v-model="form.code" required />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Name">
              <b-form-input v-model="form.name" required />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Description">
              <b-form-textarea v-model="form.Description" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Type">
              <b-form-select v-model="form.Type" :options="typeOptions" required />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Balance">
              <b-form-input v-model.number="form.Balance" type="number" min="0" />
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group label="Tax Type">
              <b-form-input v-model="form.TaxType" required />
            </b-form-group>
          </b-col>  -->
          <!-- <b-col md="6" class="d-flex align-items-center">
            <b-form-group class="mb-0" label="Is Sub Account ?">
              <b-form-checkbox v-model="form.isSubAccount" switch></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Parent Account">
              <b-form-select v-model="form.parentAccount" :options="getParentAccountOptions"
                :disabled="!form.isSubAccount" />
            </b-form-group>
          </b-col> -->
        </b-row>
        <div class="text-right">
          <b-button @click="$bvModal.hide('addModal')" class="mr-1" variant="secondary">Cancel</b-button>
          <button type="submit" class="btn btn-primary">
            <b-spinner small v-if="loading" class="mx-2" />Submit
          </button>
        </div>
      </b-form>
    </b-modal>


    <!-- Per Page Dropdown -->
    <b-col cols="12" sm="2" md="3" class="mb-2">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50  w-sm-100" />
      </b-form-group>
    </b-col>

    <!-- Add New Button -->
    <b-col cols="12" sm="3" class="mb-2 text-right text-sm-right text-md-left">
      <b-button v-b-tooltip.hover="'Add Chart of Account'" variant="success" class="btn-icon w-100 w-sm-auto"
        @click="openAddModal('addModal')">
        <feather-icon icon="PlusIcon" />
        Add New
      </b-button>
    </b-col>


    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" @click="clearFilters" :disabled="!anyFilterActive">
        Clear Filters
      </b-button>
    </b-col>

    <!--COA Listing table -->
    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :fields="fields"
        :items="filteredCOA" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">

        <!-- Code Filter -->
        <template #head(code)>
          <div class="d-flex flex-column">
            <span>Code</span>
            <b-form-input v-model="columnFilters.code" placeholder="Filter by Code" size="sm" @input="filterTable" />
          </div>
        </template>

        <!-- Name Filter -->
        <template #head(name)>
          <div class="d-flex flex-column">
            <span>Name</span>
            <b-form-input v-model="columnFilters.name" placeholder="Filter by Name" size="sm" @input="filterTable" />
          </div>
        </template>

        <!-- Description Filter -->
        <template #head(description)>
          <div class="d-flex flex-column">
            <span>Description</span>
            <b-form-input v-model="columnFilters.description" placeholder="Filter by Description" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- A virtual column -->
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <!-- A custom formatted column -->
        <template #cell(name)="data">
          {{ data.value }}
        </template>

        <template #cell(accountType)="data">
          <b-badge pill variant="primary">
            {{ getAccountTypeText(data.item.accountType) }}
          </b-badge>
        </template>

        <!-- A virtual composite column -->
        <template #cell(Balance)="data">
          {{ "Rs" + data.value }}
        </template>

        <!-- Actions column using #cell() slot -->
        <template #cell(Actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="viewDetails(data.item)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>



            <b-dropdown-item @click="openEditModal(data.item)" v-if="!data.item.isSystem">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <!-- <b-dropdown-item>
            <feather-icon icon="TrashIcon" class="mr-50" />
            <span>Delete</span>
          </b-dropdown-item> -->
          </b-dropdown>
        </template>

        <!-- Optional default data cell scoped slot -->
        <template #cell()="data">
          {{ data.value }}
        </template>
      </b-table>

      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </b-col>
    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
    </b-col>

  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BButton,
  BSpinner,
  BNavbarNav, BNavItem, VBTooltip,
  BDropdown,
  BDropdownItem,
  BModal,
  BFormTextarea,
  BForm,
  BInputGroupAppend
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BButton,
    BSpinner,
    BNavbarNav, BNavItem, VBTooltip,
    BDropdown,
    BDropdownItem,
    BModal,
    BFormTextarea,
    BForm,
    BInputGroupAppend,
  },
  data() {
    return {
      code: "",
      name: "",
      description: "",
      accountType: "",
      currentBalance: "",
      items: [],

      showSpinner: true,
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "name", // Default sorting column
      sortDesc: false, // Default ascending order
      sortDirection: "asc", // Allows ascending and descending order
      filter: null,
      filterOn: [],
      token: localStorage.getItem("accessToken"),
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      showModal: false,
      showEditModal: false,
      isSubAccount: false,
      isAddModalVisible: false,
      typeOptions: [
        { value: "0", text: "Current Asset" },
        { value: "1", text: "Fixed Asset" },
        { value: "2", text: "Equity" },
        { value: "3", text: "Current Liability" },
        { value: "4", text: "Non Current Liability" },
        { value: "5", text: "Other Income" },
        { value: "6", text: "Expense" },
        { value: "7", text: "Sales" },
        { value: "8", text: "Bank" },
      ],

      filter: null,
      filterOn: [],
      fields: [
        { key: "code", label: "Code", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "accountType", label: "Type", sortable: true },
        { key: "currentBalance", label: "Balance", sortable: true },
        { key: "Actions", label: "Actions" } // Non-sortable action column
      ],

      selectedItem: {
        name: "",
        code: "",
        accountType: "",
        Description: "",
        Balance: 0,
        TaxType: "",
        isSubAccount: false,
        parentAccount: "",
      }, // Initialize with default values representing an empty item
      form: {
        code: "",
        name: "",
        Description: "",
        accountType: "",
        Balance: "",
        TaxType: "",
        isSubAccount: false,
        parentAccount: "",
      },
      columnFilters: {
        code: "",
        name: "",
        description: ""
      },
    };
  },


  computed: {
    anyFilterActive() {
      return this.columnFilters.code || this.columnFilters.name || this.columnFilters.description;
    },
    filteredCOA() {
      return this.chartofaccount.filter((item) => {
        const matchesCode = !this.columnFilters.code || item.code.toLowerCase().includes(this.columnFilters.code.toLowerCase());
        const matchesName = !this.columnFilters.name || item.name.toLowerCase().includes(this.columnFilters.name.toLowerCase());
        const matchesDescription = !this.columnFilters.description || item.description.toLowerCase().includes(this.columnFilters.description.toLowerCase());

        return matchesCode && matchesName && matchesDescription;
      });
    },
    getParentAccountOptions() {
      return this.items
        .filter((item) => !item.isSubAccount) // 👈 only allow top-level accounts as parents
        .map((item) => ({
          value: item.code,
          text: `${item.code} - ${item.name}`, // Display code and name nicely
        }));
    },

    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("chartofaccountModule", {
      chartofaccount: "chartofaccount",
      loading: "loading",
    }),
  },


  methods: {
    success() {
      this.$swal({
        title: "Chart Of Account!",
        text: "You have successfully added the Chart Of Account!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getAccountTypeText(accountType) {
      const option = this.typeOptions.find(opt => parseInt(opt.value) === parseInt(accountType));
      return option ? option.text : "Unknown";
    },
    filterTable() {
      this.currentPage = 1; // Reset pagination when filtering
      this.totalRows = this.filteredCOA.length;
    },
    successEdit() {
      this.$swal({
        title: "Chart Of Account!",
        text: "You have successfully updated the Chart Of Account!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    ...mapActions("chartofaccountModule", ["getChartOfAccountListAction", "addChartOfAccountAction", "updateChartOfAccountAction", "getChartOfAccountIDAction"]),
    data(data) {
      if (data) {
        this.getChartOfAccountListAction();
      }
    },

    clearFilters() {
      this.columnFilters.code = "";
      this.columnFilters.name = "";
      this.columnFilters.description = "";
      this.filterTable();
    },

    updateChartofAccount(id, value) {
      let tenant = localStorage.getItem("userTenant");
      let payload = {
        activateUser: value,
        userId: id,
      };
      axios.defaults.headers.Authorization = "Bearer " + this.token;
      //
      const url = process.env.VUE_APP_API_URL
      axios
        .post(
          url + "chartofaccount/" + id + "/toggle-status", payload

        )
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Active status changed!",

            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.getChartOfAccountListAction();
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
          this.getChartOfAccountListAction();
        });
    },
    openModal(item) {

      this.selectedItem = item;
      this.showModal = true;
    },
    viewDetails(item) {
      console.log("🚀 ~ viewDetails ~ item:", item)
      this.selectedItem = item;
      this.showModal = true;
    },
    openEditModal(item) {
      console.log("item", item);

      let parentCode = "";

      // check if parentID exists and is valid
      if (item.parentID && item.parentID !== "00000000-0000-0000-0000-000000000000") {
        parentCode = this.items.find(acc => acc.id === item.parentID)?.code || "";
      }

      this.selectedItem = {
        ...item,
        accountType: String(item.accountType),
        parentAccount: parentCode, // 🟢 match to the dropdown options (code)
      };

      this.showEditModal = true;
    },
    openAddModal(modalId) {
      this.form = {
        code: "",
        name: "",
        Description: "",
        accountType: "",
        Balance: "",
        TaxType: "",
        isSubAccount: false,
        parentAccount: "",
      };
      this.$nextTick(() => {
        this.$bvModal.show(modalId);
      });
    },

    async AddCOA() {
      if (
        this.form.Balance === null ||
        this.form.Balance === '' ||
        isNaN(this.form.Balance)
      ) {
        this.$swal({
          title: "Validation Error",
          text: "Balance is required and must be a valid number.",
          icon: "warning",
          customClass: {
            confirmButton: "btn btn-warning",
          },
        });
        return; // Stop the process if invalid
      }
      const parentAccountId = this.form.isSubAccount
        ? this.items.find(item => item.code === this.form.parentAccount)?.id || "00000000-0000-0000-0000-000000000000"
        : "00000000-0000-0000-0000-000000000000";

      let payload = {
        code: this.form.code,
        name: this.form.name,
        description: this.form.Description,
        accountType: this.form.Type,
        currentBalance: this.form.Balance ? parseFloat(this.form.Balance) : 0,
        isSubAccount: this.form.isSubAccount,
        parentID: parentAccountId,
      };

      console.log(payload);

      try {
        await this.addChartOfAccountAction(payload);
        this.success();
        this.$bvModal.hide("addModal");
        this.form = {
          code: "",
          name: "",
          Description: "",
          accountType: "",
          Balance: "",
          TaxType: "",
          isSubAccount: false,
          parentAccount: "",
        };
      } catch (error) {
        console.log("🚀 ~ AddCOA ~ error:", error)
        this.errorAdd(error);
      }
    },

    errorAdd(error) {
      this.$swal({
        title: "Error",
        text: "An error occurred while adding the Chart Of Account.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
    },

    errorEdit(error) {
      this.$swal({
        title: "Error",
        text: "An error occurred while updating the Chart Of Account.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
    },

    async saveChanges() {
      try {
        if (this.selectedItem.currentBalance === null || this.selectedItem.currentBalance === '' || isNaN(this.selectedItem.currentBalance)) {
          this.$swal({
            title: "Validation Error",
            text: "Balance is required and must be a valid number.",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
          return; // Stop the save
        }
        const parentAccountId = this.selectedItem.isSubAccount
          ? this.items.find(item => item.code === this.selectedItem.parentAccount)?.id || "00000000-0000-0000-0000-000000000000"
          : "00000000-0000-0000-0000-000000000000";
        // Assuming you have a Vuex action called `updateChartOfAccountAction`
        let payload = {
          id: this.selectedItem.id,
          accountType: String(this.selectedItem.accountType),
          code: this.selectedItem.code,
          name: this.selectedItem.name,
          description: this.selectedItem.description,
          category: String(this.selectedItem.category ?? 0),
          isSelectable: this.selectedItem.isSelectable,
          isSystem: this.selectedItem.isSystem,
          isActive: this.selectedItem.isActive,
          isSubAccount: this.selectedItem.isSubAccount,
          parentID: parentAccountId,
          currentBalance: this.selectedItem.currentBalance ? parseFloat(this.selectedItem.currentBalance) : 0,
        };
        console.log("selecteditem", payload);
        await this.updateChartOfAccountAction(payload)
          .then(() => {
            this.getChartOfAccountListAction(); // ⬅️ reload table data
            this.items = [...this.chartofaccount];    // ⬅️ update parentAccount dropdown too
            this.totalRows = this.chartofaccount.length;
            this.successEdit();

            this.showEditModal = false;
          })
          .catch(() => {
            this.$swal.close();
            this.errorEdit();
          });

      } catch (error) {
        // Handle the error
        this.$swal({
          title: "Error",
          text: "An error occurred while updating the Chart Of Account.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    },
    handleOk() {
      // Handle the form submission for the add modal
      // You can access the form data using this.form
      console.log("Form submitted:", this.form);

      // Reset the form fields after submission
      this.form = {
        Code: "",
        name: "",
        Description: "",
        accountType: "",
        Balance: "",
        TaxType: "",
        isSubAccount: false,
        parentAccount: "",
      };

      // Close the add modal
      this.isAddModalVisible = false;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  // mounted() {
  //   // Set the initial number of items
  //   this.getChartofAccount();
  //   console.log(chartofaccount);
  //   this.totalRows = this.chartofaccount.length;
  // },
  async mounted() {
    await this.getChartOfAccountListAction()
      .then(() => {
        this.totalRows = this.chartofaccount.length;
        this.items = [...this.chartofaccount]; // for parent account dropdown
      })
      .catch((error) => {
        console.error(error);
      });


  },

  watch: {
    "selectedItem.isSubAccount": function (newValue) {
      if (!newValue) {
        // Reset the parent account when the "Is Sub Account" checkbox is unchecked
        this.selectedItem.parentAccount = "";
      }
    },
  },
};
</script>
